import { useEffect } from "react";

/**
 * Seeds each principal row with default `is_esignatures_principal` when missing (guardianship creation).
 * @param {{ principalCount: number, data: { guardians?: unknown[] }, updateData: function }} opts
 */
export function useGuardianshipPrincipalDefaults({ principalCount, data, updateData }) {
  useEffect(() => {
    const guardians = Array.isArray(data.guardians) ? [...data.guardians] : [];
    let changed = false;
    for (let i = 0; i < principalCount; i++) {
      if (!guardians[i]) {
        guardians[i] = { is_esignatures_principal: "No" };
        changed = true;
      } else if (guardians[i].is_esignatures_principal === undefined) {
        guardians[i] = { ...guardians[i], is_esignatures_principal: "No" };
        changed = true;
      }
    }
    if (changed) {
      updateData({ ...data, guardians });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- parity with legacy Guardians.jsx
  }, [principalCount]);
}
